module.exports = __webpack_public_path__ + "cancellara-dist/img/pellegrini.28bf8584.png";